module.exports = __webpack_public_path__ + "img/xygQiAl.f35a7fa9.png";